<template>
    <div>
        <v-dialog v-model="dialog" max-width="700px">
            <LabeledCard :label="$t('Фильтрация')">
                <slot>
                    <v-container fluid>
                        <v-row dense align="center">
                            <v-col cols="12" sm="4">
                                <span class="label font-weight-bold">{{ $t('E-mail') }}</span>
                            </v-col>
                            <v-col cols="12" sm="8">
                                <v-text-field
                                    v-model="email"
                                    dense
                                    outlined
                                    hide-details
                                    :placeholder="this.$t('Введите полное или частичное значение')"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row dense align="center">
                            <v-col cols="12" sm="4">
                                <span class="label font-weight-bold">{{ $t('Ф.И.О.') }}</span>
                            </v-col>
                            <v-col cols="12" sm="8">
                                <v-text-field
                                    v-model="name"
                                    dense
                                    outlined
                                    hide-details
                                    :placeholder="this.$t('Введите полное или частичное значение')"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row dense align="center" v-if="AHOSystemShowRule">
                            <v-col cols="12" sm="4">
                                <span class="label font-weight-bold">{{ $t('Сервисная организация') }}</span>
                            </v-col>
                            <v-col cols="12" sm="8">
                                <v-autocomplete
                                    :items="itemsTranslatedServOrgs"
                                    item-text="isas_serv_org_name"
                                    item-value="isas_serv_org_rid"
                                    v-model="isas_serv_org_rid"
                                    multiple
                                    dense
                                    outlined
                                    hide-details
                                ></v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-row dense align="center" v-if="AHSSystemShowRule">
                            <v-col cols="12" sm="4">
                                <span class="label font-weight-bold">{{ $t('Договор') }}</span>
                            </v-col>
                            <v-col cols="12" sm="8">
                                <SelectContractDialog v-model="contract" ref="selectContractDialog">
                                    <v-text-field
                                        :value="contract.contract_number"
                                        dense
                                        outlined
                                        readonly
                                        hide-details
                                        class="pointer"
                                        clearable
                                        @click:clear="clearContractSelection"
                                    ></v-text-field>
                                </SelectContractDialog>
                            </v-col>
                        </v-row>
                        <v-row dense align="center" v-if="AHSSystemShowRule">
                            <v-col cols="12" sm="4">
                                <span class="label font-weight-bold">{{ $t('КСК') }}</span>
                            </v-col>
                            <v-col cols="12" sm="8">
                                <SelectKSKDialog v-model="ksk" ref="selectKSKDialog">
                                    <v-text-field
                                        :value="ksk.isas_ksk_name"
                                        dense
                                        outlined
                                        readonly
                                        hide-details
                                        class="pointer"
                                        clearable
                                        @click:clear="clearKSKSelection"
                                    ></v-text-field>
                                </SelectKSKDialog>
                            </v-col>
                        </v-row>
                        <v-row dense align="center">
                            <v-col cols="12" sm="4">
                                <span class="label font-weight-bold">{{ $t('Роль') }}</span>
                            </v-col>
                            <v-col cols="12" sm="8">
                                <v-autocomplete
                                    :items="itemsTranslatedRoles"
                                    item-text="role_name.role_name"
                                    item-value="record_id"
                                    v-model="role_rid"
                                    multiple
                                    dense
                                    outlined
                                    hide-details
                                ></v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-row dense align="center">
                            <v-col cols="12" sm="4">
                                <span class="label font-weight-bold">{{ $t('Блокированные') }}</span>
                            </v-col>
                            <v-col cols="12" sm="8">
                                <v-radio-group v-model="active" :row="$vuetify.breakpoint.smAndUp">
                                    <v-radio v-for="n in activeList" :key="n.key" :label="n.name" :value="n.key"></v-radio>
                                </v-radio-group>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" sm="6"> </v-col>
                            <v-col cols="12" sm="3">
                                <v-btn @click="dialog = false" outlined color="gray" class="rounded-btn w100">{{ $t('Закрыть') }}</v-btn>
                            </v-col>
                            <v-col cols="12" sm="3" class="d-flex justify-end">
                                <v-btn @click="filterItems" depressed color="gray" class="rounded-btn w100">{{ $t('Применить') }}</v-btn>
                            </v-col>
                        </v-row>
                    </v-container>
                </slot>
            </LabeledCard>
        </v-dialog>
        <v-btn :title="$t('Фильтр')" icon :color="$vuetify.theme.themes.dark.primary" class="mr-1" @click="dialog = true">
            <v-icon>mdi-filter</v-icon>
        </v-btn>
        <v-btn :title="$t('Очистить фильтр')" icon :color="$vuetify.theme.themes.dark.primary" :disabled="!filter" @click="clearFilter">
            <v-icon :color="'red'">mdi-filter-remove</v-icon>
        </v-btn>
    </div>
</template>

<script>
import translate from '@/utils/translate.util';
import LabeledCard from '@/components/ui/LabeledCard';
import { getFilterArray } from '@/utils/filter.util';
import { mapActions, mapState } from 'vuex';
import SelectKSKDialog from './SelectKSKDialog.vue';
import SelectContractDialog from './SelectContractDialog.vue';

export default {
    components: {
        LabeledCard,
        SelectKSKDialog,
        SelectContractDialog
    },
    data: () => ({
        dialog: false,
        email: null,
        name: null,
        role_rid: [],
        active: -1,
        isas_serv_org_rid: [],
        ksk: {},
        contract: {},
        resetFilter: false
    }),
    watch: {
        resetFilter(val) {
            if (val === true) {
                this.clearFilter();
            }
        }
    },
    methods: {
        ...mapActions('users', ['getRoleList', 'getServOrgList', 'getUserList']),
        addFilter(val) {},
        clearFilter() {
            this.email = null;
            this.name = null;
            this.role_rid = [];
            this.active = -1;
            this.isas_serv_org_rid = [];
            this.ksk = {};
            this.contract = {};
            this.resetFilter = true;
            this.$store.commit('users/setFilter', null);
            this.getUserList();
            setTimeout(() => {
                this.resetFilter = false;
            }, 500);
        },
        filterItems() {
            const obj = {
                name: this.name,
                email: this.email,
                role_rid: this.role_rid,
                active: this.active === -1 ? null : this.active === 1 ? true : false,
                isas_serv_org_rid: this.isas_serv_org_rid,
                isas_ksk_rid: [this.ksk?.isas_ksk_rid] || null,
                isas_contract_rid: [this.contract?.isas_contract_rid] || null
            };

            const processedArrayWithFilters = getFilterArray(obj);

            if (processedArrayWithFilters.length > 0) {
                let arrayFilter = {
                    where: [...processedArrayWithFilters]
                };
                this.$store.commit('users/setFilter', arrayFilter);
            } else {
                this.$store.commit('users/setFilter', null);
            }
            this.dialog = false;
            this.getUserList();
        },

        clearKSKSelection() {
            this.$refs.selectKSKDialog.clearSelection();
        },

        clearContractSelection() {
            this.$refs.selectContractDialog.clearSelection();
        }
    },
    async mounted() {
        // await this.getRoleList();
        // await this.getServOrgList();
    },
    computed: {
        ...mapState('permissions', ['userPermissions']),
        ...mapState('users', ['roleList', 'servOrgList', 'filter']),

        itemsTranslatedServOrgs() {
            const so = translate(this.servOrgList, 'full', this.$i18n.locale);
            so.sort((a, b) => a.isas_serv_org_name.localeCompare(b.isas_serv_org_name));
            return so;
        },
        itemsTranslatedRoles() {
            const rol = translate(this.roleList, 'full', this.$i18n.locale);
            rol.sort((a, b) => a.role_name.role_name.localeCompare(b.role_name.role_name));
            return rol;
        },
        activeList: function() {
            return [
                { name: this.$t('Все'), key: -1 },
                { name: this.$t('Активные'), key: 1 },
                { name: this.$t('Заблокированные'), key: 0 }
            ];
        },

        AHSSystemShowRule() {
            return this.userPermissions.some(x => x === 'system_ahs');
        },
        AHOSystemShowRule() {
            return this.userPermissions.some(x => x === 'system_aho');
        }
    }
};
</script>
